<div class="on-off-container" (click)="activeDisactive()">
    <mat-card class="size-on-of-button " [ngClass]="{'select':(isOn$|async),'disabled':form.disabled}">
        <mat-card class="size-circle hidden-off">
        </mat-card>
        <div class="text hidden-off">{{offText}}</div>
        <div class="text hidden-on">{{onText}}</div>
        <mat-card class="size-circle hidden-on">
        </mat-card>
    </mat-card>
</div>